import React, { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:scale-[0.99]",
  {
    variants: {
      variant: {
        // Sem literal de cor: as variantes obedecem aos tokens do tema, e so a eles.
        // Um literal aqui vaza para todas as telas do sistema.
        // Ação principal em amarelo da marca (--action), não no vermelho: decisão do dono em 2026-09-15.
        primary:
          "border border-transparent bg-action text-action-foreground shadow-sm hover:bg-action/90",
        default:
          "border border-transparent bg-action text-action-foreground shadow-sm hover:bg-action/90",
        gold: "border border-transparent bg-gold text-gold-foreground shadow-sm hover:bg-gold/90",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/85",
        outline: "border border-border bg-background hover:bg-accent hover:text-accent-foreground",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        danger: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4",
        lg: "h-11 px-6 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

const Button = forwardRef(function Button(
  {
    children,
    variant = "primary",
    size = "md",
    icon,
    iconPosition = "left",
    className = "",
    ...props
  },
  ref
) {
  return (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props}>
      {icon && iconPosition === "left" && <i className={`bi ${icon}`} aria-hidden="true" />}
      {children}
      {icon && iconPosition === "right" && <i className={`bi ${icon}`} aria-hidden="true" />}
    </button>
  );
});

export default Button;
